import { render, staticRenderFns } from "./staffLeaveList.vue?vue&type=template&id=89194e9e&scoped=true"
import script from "./staffLeaveList.vue?vue&type=script&lang=js"
export * from "./staffLeaveList.vue?vue&type=script&lang=js"
import style0 from "./staffLeaveList.vue?vue&type=style&index=0&id=89194e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89194e9e",
  null
  
)

export default component.exports